module.exports = __webpack_public_path__ + "static/media/Asset3.1a11c32b.png";